﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

//No internet
require('typeahead-addresspicker');

import tpl_order from './tpl/order.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';

import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import config from '../../../common/config';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import * as Entities_PublicRecaptchaRegister from '../../entities/publicRecaptchaRegister';  

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_order({ model: this.model.toJSON() });
    },
    initialize: function () {
        var self = this;
        this.app = this.options.app;
        this.price_localSetting = this.options.price_localSetting;

        this.informationCollection = new Entities_Empty.Collection();

        this.localSetting = new Entities_Empty.Model();

        var selectedElement = '#order_iPrivate';
        switch (this.model.attributes.Organisation) {
            case 0 : selectedElement = '#order_iPrivate'; break;
            case 1 : selectedElement = '#order_iCompany'; break;
            case 2 : selectedElement = '#order_iSociety'; break;
        }

        this.localSetting.attributes.selectedElement = selectedElement;

        this.app.entities.collections.publicConfigSubscriptionPayment.forEach(function (entry) {
            if (entry.attributes.IsDefault) {
                self.model.attributes.ConfigSubscriptionPaymentId = entry.attributes.id;
            }
        });

        this.model.attributes.SubTotal = 0;
        this.model.attributes.SubTotalNoVat = 0;
        this.model.attributes.SubTotalVat = 0;
        this.model.attributes.Total = 0;
        this.model.attributes.Currency = language.getCurrencyFromCultureName(config.cultureName());

        this.collection.forEach(function (entry) {
            if (entry.attributes.Vat == 1) {
                self.model.attributes.SubTotalNoVat +=  entry.attributes.Qty * entry.attributes.Price;
            } else {
                self.model.attributes.SubTotal +=  entry.attributes.Qty * entry.attributes.Price;
                self.model.attributes.SubTotalVat += entry.attributes.Qty * ((entry.attributes.Vat * entry.attributes.Price) - entry.attributes.Price);
            }
        });
        self.model.attributes.Total =  self.model.attributes.SubTotal + self.model.attributes.SubTotalNoVat + self.model.attributes.SubTotalVat;
    },
    test : function() {
        this.model.attributes.FirstName = 'Steen';
        this.model.attributes.Phone = '121212';
        this.model.attributes.Email = 'steenhansenden@gmail.com';
        this.model.attributes.Password =  'qweQWE123!';
        this.model.attributes.PasswordConfirm = 'qweQWE123!';
        this.model.attributes.Address = 'Lille Roldvej 1, 5492 Vissenbjerg, Danmark';

        this.ui.order_inputFirstName.val(this.model.attributes.FirstName);
        this.ui.order_inputPhone.val(this.model.attributes.Phone);
        this.ui.order_inputEmail.val(this.model.attributes.Email);
        this.ui.order_inputPassword.val(this.model.attributes.Password);
        this.ui.order_inputPasswordConfirm.val(this.model.attributes.PasswordConfirm);
        this.ui.order_inputAddress.val(this.model.attributes.Address);
    },
    regions: {
        information: "#orderInformation"
    },
    onBeforeShow: function () {
        this.information.show(new View_Information({ collection: this.informationCollection, app : this.app }));
    },
    ui: {
        'order_btnPrivate' : '#order_btnPrivate',
        'order_btnCompany' : '#order_btnCompany',
        'order_btnSociety' : '#order_btnSociety',
        'order_iPrivate' : '#order_iPrivate',
        'order_iCompany' : '#order_iCompany',
        'order_iSociety' : '#order_iSociety',

        'order_pCondition' : '#order_pCondition',

        'order_labelFirstName' : '#order_labelFirstName',
        'order_divCompanyRegistration' : '#order_divCompanyRegistration',
        'order_inputCompanyRegistration' : '#order_inputCompanyRegistration',
        'order_divAttPerson' : '#order_divAttPerson',
        'order_inputAttPerson' : '#order_inputAttPerson',
        'order_inputPayment' : '#order_inputPayment',
        
        'order_btnGoogle': '#order_btnGoogleFind',
        'order_inputAddress': '#order_inputAddress',
        'order_inputFirstName': '#order_inputFirstName',
        'order_inputSecondName': '#order_inputSecondName',
        'order_inputPhone': '#order_inputPhone',
        'order_inputAddressSupplement': '#order_inputAddressSupplement',
        'order_inputEmail' : '#order_inputEmail',
        'order_inputPassword' : '#order_inputPassword',
        'order_inputPasswordConfirm' : '#order_inputPasswordConfirm',
        'order_restart' : '#order_restart',
        'order_btnSubmit': '#order_btnSubmit',
        'order_p_verifyOK' : '#order_p_verifyOK',

        'order_subTotal' : '#order_subTotal',
        'order_subTotalNoVat' : '#order_subTotalNoVat'
    },
    events: {
        'click @ui.order_btnPrivate': 'btnPrivateClick',
        'click @ui.order_btnCompany': 'btnCompanyClick',
        'click @ui.order_btnSociety': 'btnSocietyClick',
        'change @ui.order_inputPayment': 'selectPaymentChange',
        //'change @ui.order_inputAddress': 'inputAddressChange',
        'click #order_btnSubmit': 'btnSubmitClick',
        'click #order_btnGoogleSubmit': 'btnGoogleFind',
        'click #order_restart': 'btnRestartClick'
    },
    onRender: function () {
        if (this.model.attributes.SubTotalNoVat > 0) {
            this.ui.order_subTotalNoVat.show();
            this.ui.order_subTotal.text(resources.X100873);
        } else {
            this.ui.order_subTotalNoVat.css('display', 'none');
            this.ui.order_subTotal.text(resources.X100852);
        }
    },
    onAttach(){
        var self = this;

        this.btnAddCheck(this.localSetting.attributes.selectedElement);
        this.recalculate();

        //No internet
        this.addressPicker = new AddressPicker();
        this.ui.order_inputAddress.typeahead(null, {
            displayKey: 'description',
            source: self.addressPicker.ttAdapter()
        });

        this.addressPicker.bindDefaultTypeaheadEvent(this.ui.order_inputAddress);
        $(this.addressPicker).on('addresspicker:selected', function (event, parsedGeocodeResult) {
            var _parsedGeocodeResult = self._parseGeocodeResult(parsedGeocodeResult.placeResult);

            //self.ui.order_inputAddress.val(_parsedGeocodeResult.formatted_address);

            if (_parsedGeocodeResult.type != "street_address") {
                self.model.attributes.WrongAddress = false;
            }
            else {
                self.model.attributes.WrongAddress = true;

                self.setModel(_parsedGeocodeResult);
            }
            self.updateInformationCollection();
        });

        $(this.addressPicker).on('addresspicker:change', function (event, parsedGeocodeResult) {
            var _parsedGeocodeResult = self._parseGeocodeResult(parsedGeocodeResult.placeResult);

            //self.ui.order_inputAddress.val(_parsedGeocodeResult.formatted_address);

            if (_parsedGeocodeResult.type != "street_address") {
                self.model.attributes.WrongAddress = false;
            }
            else {
                self.model.attributes.WrongAddress = true;

                self.setModel(_parsedGeocodeResult);
            }
            self.updateInformationCollection();
        });

        this.test();

        //this.loadCaptcha();
    },
    loadCaptcha: function() {
        var self = this;
        var getRecaptchaResponse = function(response) {

            var shopOrder = {};
            var shopProduct = [];
            
            
            shopOrder.id = self.model.attributes.id;
            shopOrder.FirstName = self.model.attributes.FirstName;
            shopOrder.SecondName = self.model.attributes.SecondName;
            shopOrder.Organisation = self.model.attributes.Organisation;
            shopOrder.CompanyRegistration = self.model.attributes.CompanyRegistration;
            shopOrder.CultureName = self.model.attributes.CultureName;
            shopOrder.Phone = self.model.attributes.Phone;
            shopOrder.Email = self.model.attributes.Email;
            shopOrder.Currency = self.model.attributes.Currency;
            shopOrder.AttPerson = self.model.attributes.AttPerson;
            shopOrder.EanNumber = self.model.attributes.EanNumber;
            shopOrder.UtcDate = self.model.attributes.UtcDate;

            shopOrder.Address = self.model.attributes.Address;
            shopOrder.AddressSupplement = self.model.attributes.AddressSupplement;
            shopOrder.Address_administrative_area_level_1 = self.model.attributes.Address_administrative_area_level_1;
            shopOrder.Address_administrative_area_level_2 = self.model.attributes.Address_administrative_area_level_2;
            shopOrder.Address_administrative_area_level_3 = self.model.attributes.Address_administrative_area_level_3;
            shopOrder.Address_country = self.model.attributes.Address_country;
            shopOrder.Address_countryKey = self.model.attributes.Address_countryKey;
            shopOrder.Address_lat = self.model.attributes.Address_lat;
            shopOrder.Address_lng = self.model.attributes.Address_lng;
            shopOrder.Address_locality = self.model.attributes.Address_locality;
            shopOrder.Address_postal_code = self.model.attributes.Address_postal_code;
            shopOrder.Address_route = self.model.attributes.Address_route;
            shopOrder.Address_street_number = self.model.attributes.Address_street_number;
            shopOrder.Address_sublocality = self.model.attributes.Address_sublocality;

            shopOrder.SubTotal = self.model.attributes.SubTotal;
            shopOrder.SubTotalNoVat = self.model.attributes.SubTotalNoVat;
            shopOrder.SubTotalVat = self.model.attributes.SubTotalVat;
            shopOrder.Total = self.model.attributes.Total;

            shopOrder.DineroInvoiceGuid = self.model.attributes.DineroInvoiceGuid;
            shopOrder.DineroInvoiceNumber = self.model.attributes.DineroInvoiceNumber;
            shopOrder.DineroInvoicePaymentStatus = self.model.attributes.DineroInvoicePaymentStatus;
            shopOrder.DineroInvoicePaymentDepositAccountNumber = self.model.attributes.DineroInvoicePaymentDepositAccountNumber;
            shopOrder.PaymentType = self.model.attributes.PaymentType;
            shopOrder.PaymentGatewayType = self.model.attributes.PaymentGatewayType;
            shopOrder.PaymentGatewayUtcDate = self.model.attributes.PaymentGatewayUtcDate;
            shopOrder.PaymentGatewayResult = self.model.attributes.PaymentGatewayResult;

            var product = {};
            var freight = {};
            self.collection.forEach(function (entry) {
                product = {};
                product.id = entry.attributes.id;
                product.Qty = entry.attributes.Qty;
                product.ShopOrder = entry.attributes.ShopOrder;
                product.CultureName = entry.attributes.CultureName;
                product.Currency = entry.attributes.Currency;
                product.ItemId = entry.attributes.ItemId;
                product.Name = entry.attributes.Name;
                product.InvoiceDescriptionText = entry.attributes.InvoiceDescriptionText;
                product.InvoiceCommentsText = entry.attributes.InvoiceCommentsText;
                product.AccountNumber = entry.attributes.AccountNumber;
                product.Price = entry.attributes.Price;
                product.Vat = entry.attributes.Vat; //* entry.attributes.Price) - entry.attributes.Price;
                //product.FreightProduct = entry.attributes.FreightProduct;

                shopProduct.push(product);
            });

            var recaptchaResponseShopOrder = {
                response: response,
                Text01 : resources.X100689,
                Text04 : resources.X100836,
                Text05 : resources.X100839,
                ShopOrder : shopOrder,
                ShopProduct : shopProduct
            }

            var url = config.webApiUrl() + '/api/publicRecaptcha/shoporder/-1';

            $.ajax({
                type: "POST",
                url: url,
                dataType: 'json',
                contentType: "application/json",
                data: JSON.stringify(recaptchaResponseShopOrder),
                //beforeSend: function(xhr, settings) { xhr.setRequestHeader('Authorization', "Bearer ".concat(window['mgr'].access_token)); },
                success: function (response) {
                    window.app.router.navigate("#orderMailSendSucces");
                    window.app.router.orderMailSendSucces(response.ShopOrderId);
                }
            });

            /*self.model.attributes.response = response;
    
            self.model.save(self.attributes, {
                route : 'shoporder',
                silent: true,
                wait:true,
                //dataType: 'text',
                success: function (mode, response) {
                    window.app.router.navigate(response.Url);
                    window.app.router.messageWithName(response.HeaderNumber, response.TitleNumber, response.FirstName, false);
                },
                error: function (mode, response) {
                }
            });*/

        };

        var renderCaptcha = function() {
            self.captchaWidgetId = grecaptcha.render('recaptcha-container', {
                sitekey : config.googleRecaptchaSiteKey(),
                callback: getRecaptchaResponse
            });
        };

        window.renderCaptcha = renderCaptcha;

        $.getScript('https://www.google.com/recaptcha/api.js?onload=renderCaptcha&render=explicit', function() { });
    },
    onDestroy(){
        $(this.addressPicker).unbind();
    },
    renderInformation: function () {
        this.informationCollection.reset();
    },
    updateInformationCollection: function () {
        this.renderInformation();
        this.informationCollection.trigger('change');
    },
    order_btnVatClick: function (event) {
        event.preventDefault();

        this.localSetting.attributes.selectedVat = !this.localSetting.attributes.selectedVat;
        this.setupVat();

        this.recalculate();
    },
    setupVat: function () {
        if (this.localSetting.attributes.selectedVat) {
            this.ui.order_iVat.addClass('fa-check-square');
            this.ui.order_iVat.removeClass('fa-square');
            this.ui.order_pTotalPriceText.html('<strong>' + resources.X100588 + '</strong>');
        } else {
            this.ui.order_iVat.removeClass('fa-check-square');
            this.ui.order_iVat.addClass('fa-square');
            this.ui.order_pTotalPriceText.html('<strong>' + resources.X100587 + '</strong>');
        }
    },
    recalculate : function () {
        this.setupPayment(this.model.attributes.TotalPrice, this.model.attributes.TotalPriceInclVat);
        this.setupCondition(this.model.attributes.TotalPrice, this.model.attributes.TotalPriceInclVat);

        var self = this;

        
    },
    buildPaymentInputMultipleChoise : function(totalPrice, totalPriceInclVat) {
        var self = this;

        var start01 = '<div class="row"><div class="col-sm-6 col-md-6">'
        var end01 = '</div>'

        var start02 = '<div class="col-sm-6 col-md-6">'
        var end02 = '</div></div>'

        var str_payment = '';

        this.app.entities.collections.publicConfigSubscriptionPayment.forEach(function (entry) {
            
            str_payment += start01;
            

            //str_payment +=  '<p>' + entry.attributes.Name + '</p>'

            /*if (this.model.attributes.ConfigSubscriptionPaymentId == -1) {
    
                if (entry.attributes.IsDefault) {
                    str_payment += '<label><input checked="checked" type="radio" name="order_inputPaymentValue" value="' + entry.attributes.id + '">' + entry.attributes.Name + '</label></br>';
                    self.localSetting.attributes.paymentId = entry.attributes.id;
                } else {
                    str_payment += '<label><input type="radio" name="order_inputPaymentValue" value="' + entry.attributes.id + '">' + entry.attributes.Name + '</label></br>';
                }
            } else {*/
            if (entry.attributes.id == self.model.attributes.ConfigSubscriptionPaymentId) {
                str_payment += '<label><input checked="checked" type="radio" name="order_inputPaymentValue" value="' + entry.attributes.id + '">' + entry.attributes.Name + '</label></br>';
                //self.localSetting.attributes.paymentId = entry.attributes.id;
            } else {
                str_payment += '<label><input type="radio" name="order_inputPaymentValue" value="' + entry.attributes.id + '">' + entry.attributes.Name + '</label></br>';
            }
            //}

            var description01 = '';

            if (entry.attributes.FormatText) {
                switch(entry.attributes.FormatType) {
                    case 0 : description01 = '<p>' + entry.attributes.Description01 + '</p>';  break;
                    case 3 : description01 = '<p>' + String.format(entry.attributes.Description01, totalPriceInclVat + ' ' + entry.attributes.Currency) + '</p>'; break;
                }
            } else {
                description01 = '<p>' + entry.attributes.Description01 + '</p>';  
            }
            
            str_payment += description01;

            str_payment += end01;
            str_payment += start02;

            if (entry.attributes.Image && entry.attributes.Image.length > 0) {
                str_payment +=  '<image src="' + entry.attributes.Image + '"/>'
            }

            str_payment += end02;
        });

        return str_payment;
    },
    setupPayment: function (totalPrice, totalPriceInclVat) {
        var str_payment = '';
        str_payment = this.buildPaymentInputMultipleChoise(totalPrice, totalPriceInclVat);

        this.ui.order_inputPayment.html(str_payment);
    },
    setupCondition: function (totalPrice, totalPriceInclVat) {
        var str_payment = '';

        
        var entry = this.app.entities.collections.publicConfigSubscriptionPayment.where( {id : this.model.attributes.ConfigSubscriptionPaymentId} );

        if (entry && entry.length > 0) {
            str_payment = entry[0].attributes.Description02;
        }

        this.ui.order_pCondition.html(str_payment);
    },
    btnPrivateClick: function (event) {
        event.preventDefault();
        
        this.btnAddCheck('#order_iPrivate');
    },
    btnCompanyClick: function (event) {
        event.preventDefault();

        this.btnAddCheck('#order_iCompany');
    },
    btnSocietyClick: function (event) {
        event.preventDefault();

        this.btnAddCheck('#order_iSociety');
    },
    btnRemoveCheck : function () {
        this.ui.order_iPrivate.removeClass('fa-check-square');
        this.ui.order_iCompany.removeClass('fa-check-square');
        this.ui.order_iSociety.removeClass('fa-check-square');
        this.ui.order_iPrivate.addClass('fa-square');
        this.ui.order_iCompany.addClass('fa-square');
        this.ui.order_iSociety.addClass('fa-square');
    },
    btnAddCheck : function (element) {
        this.localSetting.attributes.selectedElement = element;

        switch (this.localSetting.attributes.selectedElement) {
            case '#order_iPrivate' : this.model.attributes.Organisation = 0; break;
            case '#order_iCompany' : this.model.attributes.Organisation = 1; break;
            case '#order_iSociety' : this.model.attributes.Organisation = 2; break;
        }
        
        this.btnRemoveCheck();
        $(element).addClass('fa-check-square');
        //this.recalculate();

        var text = '';

        var showCompanyRegistration = false;
        switch (element) {
            case '#order_iPrivate' : text = resources.X100577; showCompanyRegistration = false; break;
            case '#order_iCompany' : text = resources.X100578; showCompanyRegistration = true; break;
            case '#order_iSociety' : text = resources.X100579; showCompanyRegistration = false; break;
        }

        var showAttPerson = false;
        switch (element) {
            case '#order_iPrivate' : showAttPerson = false; break;
            case '#order_iCompany' : showAttPerson = true; break;
            case '#order_iSociety' : showAttPerson = true; break;
        }
        
        this.ui.order_labelFirstName.text(text);

        if (showCompanyRegistration) {
            this.ui.order_divCompanyRegistration.show();
        } else {
            this.ui.order_divCompanyRegistration.css('display', 'none');
        } 

        if (showAttPerson) {
            this.ui.order_divAttPerson.show();
        } else {
            this.ui.order_divAttPerson.css('display', 'none');
        } 
    },
    selectPaymentChange: function (event) {
        var val = $('input[name=order_inputPaymentValue]:checked').val(); 
        this.model.attributes.ConfigSubscriptionPaymentId = parseInt(val);

        this.recalculate();
    },
    btnSubmitClick: function (event) {
        var self = this;
        this.hideErrors();

        if (event != null) {
            event.preventDefault();
        }

        if (this.setModel()) {
            //this.save();
            var callback = function (ret) {
                if (ret == true) {
                    self.loadCaptcha();
                    self.ui.order_p_verifyOK.show();
                    self.ui.order_btnSubmit.css('display', 'none');
                } else  {
                    self.showErrors(self.model.errors);
                    $('html,body').scrollTop(0);
                } 
            }
            this.model.validateNoBackbone(this.model.attributes, this.app, callback);
        }
    },
    btnRestartClick: function (event) {
        window.app.router.navigate("#order");
        window.app.router.price();
    },
    setModel: function (parsedGeocodeResult) {
        this.recalculate();
        var now = new Date();
        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(1);

        var utcDateTime = now.getUTCFullYear().toString() + '-' +
                   (now.getUTCMonth() + 1) + '-' +
                   now.getUTCDate().toString() + ' ' + 
                   now.getUTCHours() + ':' + 
                   now.getUTCMinutes() + ':' + 
                   now.getUTCSeconds();

        var utcDisplayDate = now.toLocaleDateString();
        utcDisplayDate = utcDisplayDate.substring(0, utcDisplayDate.length);

        var administrative_area_level_1 = '';
        var administrative_area_level_2 = '';
        var administrative_area_level_3 = '';
        var country = '';
        var countryKey = '';
        var lat = 0;
        var lng = 0;
        var locality = '';
        var postal_code = '';
        var route = '';
        var street_number = '';
        var sublocality = '';

        var configSubscriptionPayment = this.app.entities.collections.publicConfigSubscriptionPayment.where({ id : this.model.attributes.ConfigSubscriptionPaymentId});
        this.model.attributes.PaymentType = configSubscriptionPayment[0].attributes.Type;
        this.model.attributes.PaymentGatewayType = configSubscriptionPayment[0].attributes.GatewayType;


        if (parsedGeocodeResult) {
            //this.ui.order_inputAddress.val(parsedGeocodeResult.formatted_address);

            if (parsedGeocodeResult.administrative_area_level_1 != false) {
                administrative_area_level_1 = parsedGeocodeResult.administrative_area_level_1;
            }
            if (parsedGeocodeResult.administrative_area_level_2 != false) {
                administrative_area_level_2 = parsedGeocodeResult.administrative_area_level_2;
            }
            if (parsedGeocodeResult.administrative_area_level_3 != false) {
                administrative_area_level_3 = parsedGeocodeResult.administrative_area_level_3;
            }
            if (parsedGeocodeResult.country != false) {
                country = parsedGeocodeResult.country;
            }
            if (parsedGeocodeResult.lat != false) {
                lat = parsedGeocodeResult.lat;
            }
            if (parsedGeocodeResult.lng != false) {
                lng = parsedGeocodeResult.lng;
            }
            if (parsedGeocodeResult.locality != false) {
                locality = parsedGeocodeResult.locality;
            }
            if (parsedGeocodeResult.postal_code != false) {
                postal_code = parsedGeocodeResult.postal_code;
            }
            if (parsedGeocodeResult.route != false) {
                route = parsedGeocodeResult.route;
            }
            if (parsedGeocodeResult.street_number != false) {
                street_number = parsedGeocodeResult.street_number;
            }
            if (parsedGeocodeResult.sublocality != false) {
                sublocality = parsedGeocodeResult.sublocality;
            }

            if (parsedGeocodeResult.countryKey != false) {
                countryKey = parsedGeocodeResult.countryKey;
            }

            this.model.set({
                FirstName: this.ui.order_inputFirstName.val(),
                SecondName: '',
                Organisation : this.model.attributes.Organisation,
                CompanyRegistration: this.ui.order_inputCompanyRegistration.val(),
                CultureName: config.cultureName(),
                Phone: this.ui.order_inputPhone.val(),
                AccountVerify: 0,
                Deleted: false,
                ExternalSystem: "",
                Email: this.ui.order_inputEmail.val(),
                AttPerson : this.ui.order_inputAttPerson.val(),
                EanNumber : '',
                UtcDate : utcDateTime,
                Address: this.ui.order_inputAddress.val(),
                AddressSupplement: this.ui.order_inputAddressSupplement.val(),
                Address_administrative_area_level_1: administrative_area_level_1,
                Address_administrative_area_level_2: administrative_area_level_2,
                Address_administrative_area_level_3: administrative_area_level_3,
                Address_country: country,
                Address_countryKey: countryKey,
                Address_lat: lat,
                Address_lng: lng,
                Address_locality: locality,
                Address_postal_code: postal_code,
                Address_route: route,
                Address_street_number: street_number,
                Address_sublocality: sublocality,
                PaymentType : this.model.attributes.PaymentType,
                PaymentGatewayType : this.model.attributes.PaymentGatewayType
            });
        }
        else {
            this.model.set({
                FirstName: this.ui.order_inputFirstName.val(),
                SecondName: '',
                Organisation : this.model.attributes.Organisation,
                CompanyRegistration: this.ui.order_inputCompanyRegistration.val(),
                CultureName: config.cultureName(),
                Phone: this.ui.order_inputPhone.val(),
                AccountVerify: 0,
                Deleted: false,
                ExternalSystem: "",
                Email: this.ui.order_inputEmail.val(),
                AttPerson : this.ui.order_inputAttPerson.val(),
                EanNumber : '',
                UtcDate : utcDateTime,
                PaymentType : this.model.attributes.PaymentType,
                PaymentGatewayType : this.model.attributes.PaymentGatewayType
            });
        }

        return true;
    },
    save: function () {
        var self = this;
        this.hideErrors();

        var callback = function (ret) {
            if (ret == false) {

                switch (self.model.attributes.Organisation) {
                    case 0 : self.model.attributes.AttPerson = self.model.attributes.FirstName; break; //'#order_iPrivate';
                        //case 1 : self.model.attributes.AttPerson = self.model.attributes.AttPerson; break; //'#order_iCompany'; 
                        //case 2 : self.model.attributes.AttPerson = self.model.attributes.AttPerson; break; //'#order_iSociety';
                }

                var dialogWaitingModel = new Entities_Empty.Model();
                dialogWaitingModel.attributes.Title = resources.X100408;
                dialogWaitingModel.attributes.Text = resources.X100409;
                dialogWaitingModel.attributes.Button = resources.X100279;

                var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });
                var callback = function (options) {
                    self.stopListening(dialogWaiting, "dialog:okclicked", callback);
                }
                self.listenTo(dialogWaiting, "dialog:okclicked", callback);
                self.app.dialogRegion.show(dialogWaiting);

        
                self.model.save(self.model.attributes, {
                    success: function () {
                        dialogWaiting.triggerMethod('dialog:close');
                    }
                });
            } else  {
                self.showErrors(self.model.errors);
                $('html,body').scrollTop(0);
            } 
        }

        this.model.validateNoBackbone(this.model.attributes, this.app, callback);
    },
    _parseGeocodeResult: function (geocodeResult) {
        this._addressParts = {
            street_number: null, route: null, locality: null, sublocality: null,
            administrative_area_level_3: null, administrative_area_level_2: null,
            administrative_area_level_1: null, country: null, postal_code: null, type: null
        };

        this._addressPartsShort = {
            street_number: null, route: null, locality: null, sublocality: null,
            administrative_area_level_3: null, administrative_area_level_2: null,
            administrative_area_level_1: null, country: null, postal_code: null, type: null
        };

        this._parseLatAndLng = function (location) {
            var longitude, latitude;

            if (typeof (location.lat) === 'function') {
                latitude = location.lat();
                longitude = location.lng();
            } else {
                latitude = location.lat;
                longitude = location.lng;
            }

            return { lat: latitude, lng: longitude };
        };

        this._findInfo = function (result, type) {
            for (var i = 0; i < result.address_components.length; i++) {
                var component = result.address_components[i];
                if (component.types.indexOf(type) != -1) {
                    return component.long_name;
                }
            }
            return false;
        };

        this._findInfoShort = function (result, type) {
            for (var i = 0; i < result.address_components.length; i++) {
                var component = result.address_components[i];
                if (component.types.indexOf(type) != -1) {
                    return component.short_name;
                }
            }
            return false;
        };

        var parsed = this._parseLatAndLng(geocodeResult.geometry.location);
        var parsedShort = this._parseLatAndLng(geocodeResult.geometry.location);

        for (var addressPart in this._addressParts) {
            parsed[addressPart] = this._findInfo(geocodeResult, addressPart);
        }

        for (var addressPart in this._addressParts) {
            parsedShort[addressPart] = this._findInfoShort(geocodeResult, addressPart);
        }

        parsed.type = geocodeResult.types[0];
        parsed.formatted_address = geocodeResult.formatted_address;

        parsed.countryKey = parsedShort.country;

        return parsed;
    }
}, Backbone.Radio.Requests);
